<template>
  <div>
    <a
      v-if="index > 0"
      href="javascript:void(0)"
      @click="$emit('onMove', 'left')"
      style="margin-right: 10px"
    >
      <v-icon color="primary">keyboard_arrow_left</v-icon>
    </a>
    <a v-if="index < lastIndex" href="javascript:void(0)" @click="$emit('onMove', 'right')">
      <v-icon color="primary">keyboard_arrow_right</v-icon>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    index: {},
    max: {}
  },
  computed: {
    lastIndex: function () {
      return this.max - 1
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/MoveHorizontal.vue